import React from 'react';

import ReactRender from '../tools/react-render';
import DriverSeasons from '../components/Database/Tables/DriverSeasons';
import DriverTeams from '../components/Database/Tables/DriverTeams';
import DriverRaces from '../components/Database/Tables/DriverRaces';
import TeamSeasons from '../components/Database/Tables/TeamSeasons';
import TeamRaces from '../components/Database/Tables/TeamRaces';
import CircuitRaces from '../components/Database/Tables/CircuitRaces';
import RaceQualifying from '../components/Database/Tables/RaceQualifying';
import RaceResults from '../components/Database/Tables/RaceResults';
import ChampionshipStandings from '../components/Database/Tables/ChampionshipStandings';
import ChampionshipRaces from '../components/Database/Tables/ChampionshipRaces';

const DriverSeasonsTables = document.querySelectorAll('[data-behaviour="driver-seasons-table"]');

DriverSeasonsTables.forEach(table => {
    const driverId = table.getAttribute('data-driver-id');
    const permalink = table.getAttribute('data-permalink');

    ReactRender(<DriverSeasons driver={driverId} permalink={permalink} />, table);
});

const TeamTables = document.querySelectorAll('[data-behaviour="team-seasons-table"]');

TeamTables.forEach(table => {
    const teamId = table.getAttribute('data-team-id');
    const permalink = table.getAttribute('data-permalink');
    const title = table.getAttribute('data-title');

    ReactRender(<TeamSeasons team={teamId} permalink={permalink} title={title} />, table);
});

const DriverTeamsTables = document.querySelectorAll('[data-behaviour="driver-teams-table"]');

DriverTeamsTables.forEach(table => {
    const driverId = table.getAttribute('data-driver-id');
    const permalink = table.getAttribute('data-permalink');

    ReactRender(<DriverTeams driver={driverId} permalink={permalink} />, table);
});

const DriverRacesTables = document.querySelectorAll('[data-behaviour="driver-races-table"]');

DriverRacesTables.forEach(table => {
    const driverId = table.getAttribute('data-driver-id');
    const permalink = table.getAttribute('data-permalink');

    ReactRender(<DriverRaces driver={driverId} permalink={permalink} />, table);
});

const TeamsRacesTables = document.querySelectorAll('[data-behaviour="team-races-table"]');

TeamsRacesTables.forEach(table => {
    const teamId = table.getAttribute('data-team-id');
    const permalink = table.getAttribute('data-permalink');

    ReactRender(<TeamRaces team={teamId} permalink={permalink} />, table);
});

const CircuitRacesTables = document.querySelectorAll('[data-behaviour="circuit-races-table"]');

CircuitRacesTables.forEach(table => {
    const circuitId = table.getAttribute('data-circuit-id');
    const permalink = table.getAttribute('data-permalink');

    ReactRender(<CircuitRaces circuit={circuitId} permalink={permalink} />, table);
});

const RaceQualifyingTables = document.querySelectorAll('[data-behaviour="race-qualifying-table"]');

RaceQualifyingTables.forEach(table => {
    const raceId = table.getAttribute('data-race-id');
    const raceSprint = table.getAttribute('data-race-sprint');
    const permalink = table.getAttribute('data-permalink');

    ReactRender(<RaceQualifying race={raceId} raceSprint={raceSprint} permalink={permalink} />, table);
});

const RaceResultsTables = document.querySelectorAll('[data-behaviour="race-results-table"]');

RaceResultsTables.forEach(table => {
    const raceId = table.getAttribute('data-race-id');
    const raceSprint = table.getAttribute('data-race-sprint');
    const permalink = table.getAttribute('data-permalink');

    ReactRender(<RaceResults race={raceId} raceSprint={raceSprint} permalink={permalink} />, table);
});

const ChampionshipStandingsTables = document.querySelectorAll('[data-behaviour="championship-standings-table"]');

ChampionshipStandingsTables.forEach(table => {
    const championshipId = table.getAttribute('data-championship-id');
    const permalink = table.getAttribute('data-permalink');

    ReactRender(<ChampionshipStandings championship={championshipId} permalink={permalink} />, table);
});

const ChampionshipRacesTables = document.querySelectorAll('[data-behaviour="championship-races-table"]');

ChampionshipRacesTables.forEach(table => {
    const championshipId = table.getAttribute('data-championship-id');
    const permalink = table.getAttribute('data-permalink');
    
    ReactRender(<ChampionshipRaces championship={championshipId} permalink={permalink} />, table);
});
